import { useEffect, useRef } from 'react'

/**
 * 설정 > MIDI — 앱 메뉴(또는 브라우저 메뉴바)에서 연 패널.
 * 바깥 클릭·Esc로 닫힘.
 */
export default function SettingsMenu({
  open = false,
  onOpenChange,
  midiStatus,
  inputs = [],
  outputs = [],
  inputId = '',
  outputId = '',
  onInputIdChange,
  onOutputIdChange,
  onRefresh,
}) {
  const rootRef = useRef(null)

  useEffect(() => {
    if (!open) return undefined
    const onDoc = (e) => {
      if (!rootRef.current?.contains(e.target)) onOpenChange?.(false)
    }
    const onKey = (e) => {
      if (e.key === 'Escape') onOpenChange?.(false)
    }
    document.addEventListener('mousedown', onDoc)
    document.addEventListener('keydown', onKey)
    return () => {
      document.removeEventListener('mousedown', onDoc)
      document.removeEventListener('keydown', onKey)
    }
  }, [open, onOpenChange])

  if (!open) return null

  const disabled = midiStatus === 'unsupported' || midiStatus === 'error'

  return (
    <div
      className={`settings-menu settings-menu--panel${typeof window !== 'undefined' && window.kordAI?.isElectron ? ' is-electron' : ''}`}
      ref={rootRef}
    >
      <div className="settings-panel" role="dialog" aria-label="MIDI 설정">
        <div className="settings-panel-head">
          <span className="settings-panel-title">MIDI</span>
          <button
            type="button"
            className="settings-refresh"
            onClick={() => onRefresh?.()}
            title="새로고침"
          >
            새로고침
          </button>
        </div>

        <label className="settings-field">
          <span className="settings-label">입력</span>
          <select
            className="settings-select"
            value={inputId}
            disabled={disabled}
            onChange={(e) => onInputIdChange?.(e.target.value)}
          >
            <option value="">선택 안 함</option>
            {inputs.map((p) => (
              <option key={p.id} value={p.id}>
                {p.name}{p.state === 'disconnected' ? ' (끊김)' : ''}
              </option>
            ))}
          </select>
        </label>

        <label className="settings-field">
          <span className="settings-label">출력</span>
          <select
            className="settings-select"
            value={outputId}
            disabled={disabled}
            onChange={(e) => onOutputIdChange?.(e.target.value)}
          >
            <option value="">Salamander Grand Piano</option>
            {outputs.map((p) => (
              <option key={p.id} value={p.id}>
                {p.name}{p.state === 'disconnected' ? ' (끊김)' : ''}
              </option>
            ))}
          </select>
        </label>
      </div>
    </div>
  )
}
